const state = {
  // 设备
  projectDevice: {},
  // 任务id
  projectPlan: {},
  // 剪切任务
  projectCutPlan: null,
  // 是否在批量添加
  batchAddShow: false,
  // 是否在批量编辑
  batchEditShow: false,
  // 计划
  scheduleData: {},
  // 是否展示信息栏
  allowRightDetail: true,
  // 视图布局(左右，上下)
  viewLayout: '',
  // 导航栏操作
  headerOperate: '',
  // 是否在按批次号搜索的状态下
  inSearch: {
    status: false,
    searchVal: '',
    searchDevice: [],
    // 是否返回了搜索结果
    isFinishRequest: false
  },
  // 批量操作时选中的任务
  selectedBatchList: []
};
const mutations = {
  SET_PROJECT_DEVICE: (_state, data) => {
    _state.projectDevice = data;
  },
  SET_PROJECT_PLAN: (_state, data) => {
    _state.projectPlan = data;
  },
  SET_PROJECT_CUT_PLAN: (_state, data) => {
    _state.projectCutPlan = data;
  },
  SET_BATCH_ADD_SHOW: (_state, data) => {
    _state.batchAddShow = data;
  },
  SET_SCHEDULE_DATA: (_state, data) => {
    _state.scheduleData = data;
  },
  SET_ALLOW_RIGHT_DETAIL: (_state, data) => {
    _state.allowRightDetail = data;
  },
  SET_VIEW_LAYOUT: (_state, data) => {
    _state.viewLayout = data;
  },
  SET_HEADER_OPERATE: (_state, data) => {
    _state.headerOperate = data;
  },
  SET_IN_SEARCH: (_state, data) => {
    _state.inSearch = data;
  },
  SET_BATCH_EDIT_SHOW: (_state, data) => {
    _state.batchEditShow = data;
  },
  SET_SELECTED_BATCH_LIST: (_state, data) => {
    _state.selectedBatchList = data;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
